<template>
    <el-container>
      <el-header class="header">
        <img class="img_logo" src="@/assets/images/logo.png" alt=""/>
        <img class="img_rectangle" src="@/assets/images/rectangle.png" alt=""/>
        <img class="img_title" src="@/assets/images/title.png" alt=""/>
        <img class="img_osp" src="@/assets/images/osp_logo.png" alt=""/>
        <div class="buts">
          <el-button class="but_home" size="mini" style="border-radius: 15px;background-color: white;border: 0;" @click="toHome" v-if="!isFinance && !isAdmin">
            <span class="sp_home"><img class="icon_home" src="@/assets/images/icon_home.png" alt=""/>首页</span>
          </el-button>
          <el-button class="but_cart" size="mini" style="border-radius: 15px;background-color: white;margin-left: 22px;border: 0;" @click="toCart" v-if="!isFinance && !isAdmin">
            <span class="sp_home"><img class="icon_cart" src="@/assets/images/icon_cart.png" alt=""/>购物车</span>
          </el-button>
          <el-button class="but_cart" size="mini" style="border-radius: 15px;background-color: white;margin-left: 22px;border: 0;" @click="toFavorites" v-if="!isFinance && !isAdmin">
            <span class="sp_home"><img class="icon_favorites" src="@/assets/images/icon_favorites.png" alt=""/>收藏夹</span>
          </el-button>
          <div class="div_exit">
          <a href="javascript:void(0);" style="color: white;text-decoration:none" class="sp_exit" @click="logout">退出<img class="icon_exit" src="@/assets/images/icon_exit.png" alt=""/></a>
          </div>
        </div>
      </el-header>
      <el-aside width="auto">
        <el-menu :collapse="isCollapse"
                 :style="{'width':sideBarWidth}"
                 background-color="rgb(249, 249, 249)"
                 text-color="rgb(153, 153, 153)"
                 active-text-color="rgb(239, 51, 69)"
                 :default-active="activeIndexAside"
        >
          <menuTree :menuList="menus" :collapse="isCollapse"></menuTree>
        </el-menu>
      </el-aside>
      <div :style="{'left':sideBarWidth}" style="position: fixed; top: 60px; bottom: 0; right: 0;">
        <router-view></router-view>
      </div>
    </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import menuTree from "./menuTree.vue";
import {logout} from "../api/login";

export default {
  name: "layout",
  components: {
    menuTree
  },
  computed: {
    ...mapGetters(["menus"]),
    ...mapGetters(["currentUser"])
  },
  data () {
    return {
      isCollapse: false,
      sideBarWidth: '260px',
      editableTabsValue: '/',
      activeIndexAside: null,
      queryParams: {
        isDeleted: 0
      },
      editableTabs: [{
        title: '首页',
        name: '/'
      }],
      extendTabs: [{
        name: '个人中心',
        path: '/system/user/profile'
      }],
      //是否为财务人员
      isFinance:false,
      //是否为管理员
      isAdmin:false
    };
  },
  watch:{
    //监听路由变化
    $route() {
      this.activeMenu(this.$route.path, this.menus);
    }
  },
  mounted () {
    this.activeMenu(this.$route.path, this.menus);
    let value = localStorage.getItem("isFinancer");
    if(value === 'true'){
      this.isFinance = true;
    }else{
      this.isFinance = false;
    }
    // console.log(this.currentUser.roles[0].roleKey)
    if(this.currentUser.roles[0].roleKey === 'osp_admin'){
      this.isAdmin = true
    }
  },
  methods: {
    activeMenu(path, menus) {
      //定位到对应的菜单位置
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i];
        if(menu.path === path) {
          this.activeIndexAside = menu.id;
          return;
        }
        if(menus[i].children && menus[i].children.length > 0) {
          this.activeMenu(path, menus[i].children);
        }
      }
    },
    routeTo(url) {
      if(this.$route.path !== url) {
        this.$router.push(url);
      }
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
          logout().then(res => {console.log(res)}).catch(()=>{console.log('退出失败')})
        }).catch(() => {});
      }).catch(() =>{
        console.log('取消退出')
      })
    },
    toHome(){
      this.routeTo('/product/buyFeed')
    },
    toCart(){
      this.routeTo('/cart/cart')
    },
    toFavorites(){
      this.routeTo('/favorite/favorite')
    },
  },

};
</script>
<style>
  * {
    margin:0;
    padding:0;
  }
  .title-bar {
    width: 260px;
  }
  .el-aside {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    background-color: #F2F3F7;
  }
  .el-menu {
    font-weight: bolder;
  }
  .header{
    /* 矩形 136 */
    position: absolute;
    width: 100%;
    height: 81px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 675px;
    background: linear-gradient(180.00deg, rgba(239,49,67,1) 0%,rgba(249,105,120,1) 100%);
  }
  .img_logo{
    /* 标识基础规范2：禾丰股份1 */
    position: absolute;
    width: 169px;
    height: 43px;
    left: 30px;
    right: 1081px;
    top: 10px;
    bottom: 687px;
  }
  .img_rectangle{
    /* 矩形 173 */
    position: absolute;
    width: 3px;
    height: 35px;
    left: 222px;
    right: 1055px;
    top: 14px;
    bottom: 691px;
  }
  .img_title{
    /* 小禾订货平台 */
    position: absolute;
    width: 226px;
    height: 56px;
    left: 186px;
    right: 856px;
    top: 14px;
    bottom: 682px;
  }
  .img_osp{
    /* OSP */
    position: absolute;
    float: right;
    width: 298px;
    height: 66px;
    right: 39px;
    top: 0;
    bottom: 672px;
    pointer-events:none
  }
  .buts{
    height: 28px;
    display: flex;
    margin-left: auto;
    justify-content: flex-end;
    margin-top: 28px;
    z-index: 1;
  }
  .but_home{
    width: 76px;
    height: 24px;
  }
  .but_cart{
    width: 88px;
    height: 24px;
  }
  .sp_home{
    color: rgb(240, 52, 70);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
    display: flex;
    margin-top: -2px;
  }
  .icon_home{
    display: flex;
    width: 15px;
    margin-top: -3px;
    margin-left: -2px;
    margin-right: 4px;
  }
  .icon_cart{
    display: flex;
    width: 15px;
    margin-top: -1px;
    margin-left: -4px;
    margin-right: 6px;
  }
  .icon_favorites{
    display: flex;
    width: 15px;
    margin-top: -1px;
    margin-left: -4px;
    margin-right: 5px;
  }
  .div_exit{
    margin-top: 2px;
    margin-left: 40px;
  }
  .sp_exit{
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .icon_exit{
    display: flex;
    width: 18px;
    margin-top: -19px;
    margin-left: 34px;
  }
  .el-message-box__btns .el-button--default{
    background: #FFFFFF;
    border: 1px solid #dcdfe6;
  }
  .el-message-box__btns .el-button--primary{
    background: #ef3143;
  }
</style>
